import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ACTION, ROUTES } from 'consts'

//antd
import { Row, Form, Upload, Select, InputNumber, Input, Checkbox, Button, notification } from 'antd'

//icons
import { ArrowLeftOutlined, PlusOutlined } from '@ant-design/icons'

//apis
import { uploadFile } from 'apis/upload'
import { addCategory, updateCategory } from 'apis/category'

import { useTranslation } from 'react-i18next'

export default function Category() {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const [fileUpload, setFileUpload] = useState(null)
  const [imageView, setImageView] = useState('')
  const [loading, setLoading] = useState(false)

  function getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const _addOrUpdateCategory = async () => {
    try {
      await form.validateFields()
      const dataForm = form.getFieldsValue()

      setLoading(true)
      const image = await uploadFile(fileUpload)
      const body = {
        ...dataForm,
        parent_id: location.state?.isChildren ? location.state.parent_id : -1,
        image: image || imageView || '',
        is_default: dataForm.is_default || false,
        description: dataForm.description || '',
      }

      let res

      if (location.state) res = await updateCategory(body, location.state.category_id)
      else res = await addCategory(body)
      setLoading(false)

      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({
            message: `${
              location.state
                ? t('category_item.update_successfully')
                : t('category_item.create_category_successfully')
            }`,
          })
          history.push(ROUTES.CATEGORIES)
        } else
          notification.error({
            message:
              res.data.mess ||
              res.data.message ||
              `${
                location.state
                  ? t('category_item.update_fail_please_try_again')
                  : t('category_item.create_category_failed')
              }`,
          })
      } else
        notification.error({
          message:
            res.data.mess ||
            res.data.message ||
            `${
              location.state
                ? t('category_item.update_fail_please_try_again')
                : t('category_item.create_category_failed')
            }`,
        })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    if (location.state) {
      form.setFieldsValue({ ...location.state })
      setImageView(location.state.image || '')
    }
  }, [])

  return (
    <div className="card-container">
      <div style={{ borderBottom: '0.75px solid #BBBCBD', paddingBottom: 15 }}>
        <Row
          align="middle"
          onClick={() => history.push(ROUTES.CATEGORIES)}
          style={{ cursor: 'pointer', width: 'max-content' }}
        >
          <ArrowLeftOutlined style={{ fontSize: 16 }} />
          <h3 style={{ marginBottom: 0, fontWeight: 700, marginLeft: 7 }}>
            {location.state
              ? t('category_item.update_category')
              : t('category_item.create_category')}
          </h3>
        </Row>
      </div>
      <div>
        <div style={{ width: '50%', margin: '25px 0px' }}>
          {t('common.image')}
          <Upload
            name="avatar"
            listType="picture-card"
            className="upload-category-image"
            showUploadList={false}
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            onChange={(info) => {
              if (info.file.status !== 'done') info.file.status = 'done'
              getBase64(info.file.originFileObj, (imageUrl) => setImageView(imageUrl))
              setFileUpload(info.file.originFileObj)
            }}
          >
            {imageView ? (
              <img src={imageView} alt="avatar" style={{ width: '100%' }} />
            ) : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>{t('common.upload')}</div>
              </div>
            )}
          </Upload>
        </div>
        <Form layout="vertical" form={form}>
          <Form.Item
            rules={[
              { required: true, message: t('category_item.please_enter_item_category_name') },
            ]}
            name="name"
            label={t('category_item.category_name')}
          >
            <Input placeholder={t('category_item.enter_category_name')} style={{ width: '50%' }} />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: t('category_item.please_enter_priority') }]}
            name="priority"
            label={t('category_item.priority')}
          >
            <InputNumber placeholder={t('category_item.enter_priority')} style={{ width: '50%' }} />
          </Form.Item>
          <Form.Item name="description" label="Mô tả">
            <Input.TextArea
              rows={4}
              placeholder={t('category_item.enter_description')}
              style={{ width: '50%' }}
            />
          </Form.Item>
          <Form.Item valuePropName="checked" name="is_default">
            <Checkbox>{t('category_item.is_default')}</Checkbox>
          </Form.Item>
       

          <Button
            onClick={_addOrUpdateCategory}
            type="primary"
            size="large"
            style={{ width: 120 }}
            loading={loading}
          >
            {location.state ? t('common.save') : t('common.create')}
          </Button>
        </Form>
      </div>
    </div>
  )
}
